"use client";

/**
 * Blog Analytics Component
 *
 * Invisible component that tracks user engagement on blog posts.
 * Add this to single blog post pages.
 */

import { useBlogAnalytics } from "@/hooks/useBlogAnalytics";

interface BlogAnalyticsProps {
  slug: string;
  enabled?: boolean;
}

export function BlogAnalytics({ slug, enabled = true }: BlogAnalyticsProps) {
  useBlogAnalytics(slug, { enabled });

  // This component renders nothing - it only tracks analytics
  return null;
}

export default BlogAnalytics;
